/* Fenando — site-wide scripts
   Loaded with defer by snippets/fenando-config.liquid. Texts and links come from window.FEN. */
window.FEN = window.FEN || {};
if (!FEN.onDom) FEN.onDom = function (fn) { new MutationObserver(fn).observe(document.documentElement, { childList: true, subtree: true }); };

/* ==================== Sara chat ==================== */
try {
/* ---------- Sara (gift assistant chat) ---------- */
(function () {
  var win = document.getElementById('fenChatWindow');
  if (!win) return;

  var C = FEN.sara;
  var closeBtn = document.getElementById('fenChatClose');
  var input = document.getElementById('fenChatInput');
  var sendBtn = document.getElementById('fenChatSend');
  var msgs = document.getElementById('fenChatMessages');
  var sugg = document.getElementById('fenChatSuggestions');
  var bubble = document.getElementById('fenAssistBubble');

  var KEEP = 30;   // messages remembered in the browser
  var SEND = 12;   // messages sent with each question (keeps answers fast and cheap)

  function loadHistory() {
    try {
      var h = JSON.parse(localStorage.getItem('fenChatHistory') || '[]');
      return Array.isArray(h) ? h.slice(-KEEP) : [];
    } catch (e) { return []; }
  }
  function saveHistory() {
    try { localStorage.setItem('fenChatHistory', JSON.stringify(history.slice(-KEEP))); } catch (e) {}
  }

  var history = loadHistory();
  var busy = false;

  // First visit in this tab: chat starts closed
  try {
    if (sessionStorage.getItem('fenHasVisited') !== 'true') {
      sessionStorage.setItem('fenHasVisited', 'true');
      sessionStorage.setItem('fenChatOpen', 'false');
    }
  } catch (e) {}

  function isOpenStored() {
    try { return sessionStorage.getItem('fenChatOpen') === 'true'; } catch (e) { return false; }
  }
  function storeOpen(v) {
    try { sessionStorage.setItem('fenChatOpen', v ? 'true' : 'false'); } catch (e) {}
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Text is escaped first, so a reply can never inject HTML or scripts.
  // Only [label](https://…) links are turned back into real links.
  function format(text) {
    return esc(text).replace(/\[([^\]]+)\]\((https?:\/\/[^\s)<>"]+)\)/g, function (m, label, url) {
      return '<a href="' + url + '" target="_blank" rel="noopener">' + label + '</a>';
    });
  }

  function addMessage(role, content) {
    var div = document.createElement('div');
    div.className = 'fen-chat-message ' + (role === 'user' ? 'user' : 'assistant');
    div.innerHTML = '<div class="fen-chat-bubble">' + format(content) + '</div>';
    msgs.appendChild(div);
    msgs.scrollTop = msgs.scrollHeight;
  }

  function showTyping() {
    var div = document.createElement('div');
    div.className = 'fen-chat-message assistant';
    div.id = 'fenTyping';
    div.innerHTML = '<div class="fen-chat-typing"><span></span><span></span><span></span></div>';
    msgs.appendChild(div);
    msgs.scrollTop = msgs.scrollHeight;
  }
  function hideTyping() {
    var t = document.getElementById('fenTyping');
    if (t) t.remove();
  }

  function open() {
    win.classList.add('open');
    if (bubble) bubble.style.display = 'none';
    storeOpen(true);
    if (window.innerWidth >= 640 && input) input.focus();
  }
  function close() {
    win.classList.remove('open');
    if (bubble) bubble.style.display = 'flex';
    storeOpen(false);
    if (bubble) bubble.focus();
  }

  // Restore earlier messages
  if (history.length) {
    history.forEach(function (m) {
      if (m && (m.role === 'user' || m.role === 'assistant')) addMessage(m.role, m.content);
    });
    if (sugg) sugg.style.display = 'none';
  }

  if (isOpenStored()) {
    win.classList.add('open');
    if (bubble) bubble.style.display = 'none';
  } else if (bubble) {
    bubble.style.display = 'flex';
  }
  msgs.scrollTop = msgs.scrollHeight;

  if (closeBtn) closeBtn.addEventListener('click', close);
  if (bubble) bubble.addEventListener('click', open);

  win.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  if (sugg) {
    sugg.querySelectorAll('.fen-chat-suggestion').forEach(function (btn) {
      btn.addEventListener('click', function () {
        input.value = btn.textContent;
        sugg.style.display = 'none';
        send();
      });
    });
  }

  if (sendBtn) sendBtn.addEventListener('click', send);
  if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') send(); });

  // The last messages, starting with a question from the visitor
  function recent() {
    var list = history.slice(-SEND);
    while (list.length && list[0].role !== 'user') list.shift();
    return list;
  }

  function send() {
    var text = (input.value || '').trim();
    if (!text || busy) return;
    input.value = '';
    busy = true;
    if (sugg) sugg.style.display = 'none';

    addMessage('user', text);
    history.push({ role: 'user', content: text });
    saveHistory();
    storeOpen(true);
    showTyping();

    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 30000);

    fetch(C.proxy, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: recent(), lang: FEN.lang, root: window.location.origin + FEN.root }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var reply = (data && data.content && data.content[0] && data.content[0].text) || C.error;
        hideTyping();
        addMessage('assistant', reply);
        history.push({ role: 'assistant', content: reply });
        saveHistory();
      })
      .catch(function () {
        hideTyping();
        addMessage('assistant', C.offline);
      })
      .then(function () {
        clearTimeout(timer);
        busy = false;
      });
  }
})();
} catch (e) { if (window.console) console.error('Fenando: Sara chat', e); }

/* ==================== Favourites ==================== */
try {
(function () {
  var KEY = 'fenWishlist';
  var WISH_URL = FEN.wishUrl;
  var T = FEN.t.wish;

  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    document.dispatchEvent(new CustomEvent('fen:wishlist', { detail: { list: list } }));
  }
  function has(handle) {
    return read().some(function (i) { return i.handle === handle; });
  }

  // ---- header count ----
  var lastCount = null;
  function badge() {
    var n = read().length;
    document.querySelectorAll('.fen-wish-nav__badge').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('visible', n > 0);
      if (lastCount !== null && n > lastCount) {
        b.classList.remove('is-bump');
        void b.offsetWidth;
        b.classList.add('is-bump');
      }
    });
    document.querySelectorAll('.fen-wish-nav').forEach(function (nav) {
      nav.classList.toggle('has-items', n > 0);
    });
    lastCount = n;
  }

  function sync() {
    var list = read();
    var saved = {};
    list.forEach(function (i) { saved[i.handle] = true; });
    document.querySelectorAll('[data-fen-heart]').forEach(function (btn) {
      var on = !!saved[btn.dataset.handle];
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    badge();
  }
  window.fenSyncHearts = sync;

  // ---- notice ----
  var toastEl, hideTimer, undoFn = null;
  function headerBottom() {
    var h = document.querySelector('header-component') || document.querySelector('header');
    if (!h) return 0;
    return Math.max(0, Math.min(h.getBoundingClientRect().bottom, 180));
  }
  function hide() {
    if (!toastEl) return;
    toastEl.classList.remove('show');
    setTimeout(function () { if (!toastEl.classList.contains('show')) toastEl.hidden = true; }, 260);
  }
  function scheduleHide(ms) {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hide, ms || 3800);
  }
  // opts: { label, title, image, link (bool), undo (function) }
  function toast(opts) {
    toastEl = toastEl || document.getElementById('fenWishToast');
    if (!toastEl) return;
    var imgWrap = document.getElementById('fenWtImgWrap');
    var img = document.getElementById('fenWtImg');
    if (opts.image) { img.src = opts.image; imgWrap.hidden = false; } else { imgWrap.hidden = true; }
    document.getElementById('fenWtLabel').textContent = opts.label || '';
    document.getElementById('fenWtTitle').textContent = opts.title || '';
    document.getElementById('fenWtLink').hidden = !opts.link;
    document.getElementById('fenWtUndo').hidden = !opts.undo;
    undoFn = opts.undo || null;
    document.getElementById('fenWtUndo').textContent = T.undo;

    toastEl.style.top = (headerBottom() + 10) + 'px';
    toastEl.hidden = false;
    void toastEl.offsetWidth;
    toastEl.classList.add('show');
    scheduleHide(opts.undo ? 5000 : 3800);
  }

  function pop(btn) {
    btn.classList.remove('is-pop');
    void btn.offsetWidth;
    btn.classList.add('is-pop');
    setTimeout(function () { btn.classList.remove('is-pop'); }, 700);
  }

  function toggle(btn) {
    var handle = btn.dataset.handle;
    if (!handle) return;
    var list = read();
    var idx = -1;
    list.forEach(function (i, n) { if (i.handle === handle) idx = n; });

    if (idx > -1) {
      var removed = list.splice(idx, 1)[0];
      write(list);
      toast({
        label: T.removed,
        title: removed.title,
        image: removed.image,
        undo: function () {
          var now = read();
          if (!now.some(function (i) { return i.handle === removed.handle; })) {
            now.splice(Math.min(idx, now.length), 0, removed);
            write(now);
          }
          hide();
        }
      });
    } else {
      var item = {
        handle: handle,
        title: btn.dataset.title || '',
        price: btn.dataset.price || '',
        image: btn.dataset.image || ''
      };
      list.push(item);
      write(list);
      pop(btn);
      toast({ label: T.saved, title: item.title, image: item.image, link: true });
    }
  }

  // Delegated, so hearts in AJAX-loaded cards work too
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fen-heart]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#fenWtUndo') && undoFn) {
      var fn = undoFn;
      undoFn = null;
      fn();
    }
  });

  document.addEventListener('mouseover', function (e) {
    if (toastEl && e.target.closest && e.target.closest('#fenWishToast')) clearTimeout(hideTimer);
  });
  document.addEventListener('mouseout', function (e) {
    if (toastEl && e.target.closest && e.target.closest('#fenWishToast') && toastEl.classList.contains('show')) scheduleHide(2000);
  });

  // Another tab changed the list
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      sync();
      document.dispatchEvent(new CustomEvent('fen:wishlist', { detail: { list: read() } }));
    }
  });

  window.fenWish = { read: read, write: write, has: has, sync: sync, toast: toast, T: T, url: WISH_URL };

  // Cards that appear later (filters, recommendations) get the right state
  FEN.onDom(function () {
      var list = read();
      var saved = {};
      list.forEach(function (i) { saved[i.handle] = true; });
      document.querySelectorAll('[data-fen-heart]:not([aria-pressed])').forEach(function (btn) {
        var on = !!saved[btn.dataset.handle];
        btn.classList.toggle('is-saved', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
} catch (e) { if (window.console) console.error('Fenando: Favourites', e); }

/* ==================== Header heart ==================== */
try {
(function () {
  var TPL = document.getElementById('fenWishNavTemplate');
  if (!TPL) return;

  // Horizon's cart button has no href and no "cart" in its class —
  // it's identified only by its aria-label, which is translated.
  function cartIcon() {
    var direct = document.querySelector('.header-actions__action[aria-label]');
    var buttons = document.querySelectorAll(
      '.header-actions__action, header button, header a, [class*="header"] button, [class*="header"] a'
    );

    for (var i = 0; i < buttons.length; i++) {
      var el = buttons[i];
      // Only the visible header — Horizon keeps a hidden mobile/desktop
      // twin in the DOM, and matching it produced a second heart.
      if (el.offsetParent === null) continue;
      var label = (el.getAttribute('aria-label') || el.textContent || '').toLowerCase();
      if (
        label.indexOf('winkelwagen') > -1 ||
        label.indexOf('cart') > -1 ||
        label.indexOf('warenkorb') > -1 ||
        label.indexOf('panier') > -1
      ) {
        return el;
      }
    }

    var href = document.querySelector('[href$="/cart"]');
    if (href) return href;

    return direct || null;
  }

  function inject() {
    // Remove hearts stranded in a hidden header variant
    document.querySelectorAll('.fen-wish-nav').forEach(function (nav) {
      if (nav.offsetParent === null) nav.remove();
    });
    if (document.querySelector('.fen-wish-nav')) return;

    var cart = cartIcon();
    if (!cart) return;

    var anchor = cart.closest('a, button') || cart;
    var node = TPL.content.firstElementChild.cloneNode(true);
    var row;

    // Horizon redraws the header after every cart change. An extra element
    // in front of (or inside) the cart drawer makes that redraw move the
    // drawer, which knocks the open drawer out of full-screen and leaves only
    // its header strip visible. So the heart goes at the END of the icon row
    // and CSS "order" shows it before the cart.
    var drawer = anchor.closest('cart-drawer-component');
    if (drawer && drawer.parentNode) {
      row = drawer.parentNode;
      row.appendChild(node);
    } else {
      anchor.parentNode.insertBefore(node, anchor);
      row = anchor.parentNode;
    }

    // Keep the icons on one line; tighten the gap on narrow screens
    if (row && row.style) {
      row.style.flexWrap = 'nowrap';
      row.style.whiteSpace = 'nowrap';
      var cs = window.getComputedStyle(row);
      if (cs.display.indexOf('flex') === -1) row.style.display = 'flex';
      row.style.alignItems = 'center';
      if (window.innerWidth < 750) {
        row.style.gap = '0.125rem';
      }
    }

    updateBadge();
  }

  function updateBadge() {
    var n = 0;
    try {
      n = (JSON.parse(localStorage.getItem('fenWishlist') || '[]') || []).length;
    } catch (e) {}

    document.querySelectorAll('.fen-wish-nav').forEach(function (nav) {
      var badge = nav.querySelector('.fen-wish-nav__badge');
      if (badge) {
        badge.textContent = n;
        badge.classList.toggle('visible', n > 0);
      }
      nav.classList.toggle('has-items', n > 0);
    });
  }

  // Keep the count fresh when hearts are clicked anywhere on the page
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-fen-heart]')) {
      setTimeout(updateBadge, 60);
    }
  });

  // And when another tab changes the wishlist
  window.addEventListener('storage', function (e) {
    if (e.key === 'fenWishlist') updateBadge();
  });

  FEN.onDom(inject);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
})();
} catch (e) { if (window.console) console.error('Fenando: Header heart', e); }

/* ==================== Free shipping bar ==================== */
try {
(function () {
var FEN_SHIP_T = { dec: FEN.t.dec, done: FEN.t.shipDone, remaining: FEN.t.shipRemaining };
(function () {
  // Drempel voor gratis verzending, in centen
  var THRESHOLD = 3999;

  var TPL = document.getElementById('fenShipTemplate');
  if (!TPL) return;

  var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', FEN_SHIP_T.dec);
  }

  function itemsContainer() {
    return (
      document.querySelector('cart-items') ||
      document.querySelector('.cart-items') ||
      document.querySelector('[class*="cart-items"]')
    );
  }

  function checkoutBtn() {
    return document.querySelector('button[name="checkout"], [href$="/checkout"]');
  }

  function inject() {
    if (document.getElementById('fenShipBar')) return;

    var node = TPL.content.firstElementChild.cloneNode(true);
    var list = itemsContainer();

    if (list && list.parentNode) {
      list.parentNode.insertBefore(node, list);
    } else {
      var btn = checkoutBtn();
      if (!btn) return;
      var anchor = btn.closest('form') || btn;
      anchor.parentNode.insertBefore(node, anchor);
    }

    update();
  }

  function update() {
    var bar = document.getElementById('fenShipBar');
    if (!bar) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price;
        var textEl = bar.querySelector('[data-fen-ship-text]');
        var fillEl = bar.querySelector('[data-fen-ship-fill]');

        if (total >= THRESHOLD) {
          bar.classList.add('is-free');
          textEl.innerHTML = CHECK + '<span>' + FEN_SHIP_T.done + '</span>';
          fillEl.style.width = '100%';
        } else {
          bar.classList.remove('is-free');
          var remaining = THRESHOLD - total;
          textEl.innerHTML = TRUCK + '<span>' + FEN_SHIP_T.remaining.replace('{amount}', money(remaining)) + '</span>';
          fillEl.style.width = Math.max(4, (total / THRESHOLD) * 100) + '%';
        }
      })
      .catch(function () {});
  }

  // Cart changes rebuild the drawer — re-inject and recalculate
  FEN.onDom(inject);

  ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(update, 300); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  setTimeout(inject, 500);
})();
})();
} catch (e) { if (window.console) console.error('Fenando: Free shipping bar', e); }

/* ==================== Gift boxes in the cart ==================== */
try {
(function () {
  var FEN_T = { add: FEN.t.giftAdd, added: FEN.t.giftAdded, fits: FEN.t.giftFits, forLabel: FEN.t.forLabel };

  var TPL = document.getElementById('fenGiftTemplate');
  if (!TPL) return;

  var msgTimer = null;
  var state = { active: null, items: [], cart: null };
  var removing = {};

  function checkoutBtn() {
    return document.querySelector(
      'form[action*="/checkout"] button[name="checkout"], button[name="checkout"], [href$="/checkout"]'
    );
  }

  // Directly under the cart items, the way my-jewellery does it
  function itemsContainer() {
    var direct =
      document.querySelector('cart-items') ||
      document.querySelector('.cart-items') ||
      document.querySelector('[class*="cart-items"]');
    if (direct) return direct;

    var lines = document.querySelectorAll('[class*="cart-item"]');
    if (lines.length) {
      var last = lines[lines.length - 1];
      var host = last.parentElement;
      while (host && host.querySelectorAll('[class*="cart-item"]').length < lines.length) {
        host = host.parentElement;
      }
      return host || last.parentElement;
    }
    return null;
  }

  function inject() {
    if (document.getElementById('fenGiftBlock')) return;

    var node = TPL.content.firstElementChild.cloneNode(true);
    var list = itemsContainer();

    if (list && list.parentNode) {
      if (list.nextSibling) list.parentNode.insertBefore(node, list.nextSibling);
      else list.parentNode.appendChild(node);
    } else {
      var btn = checkoutBtn();
      if (!btn) return;
      var anchor = btn.closest('form') || btn;
      anchor.parentNode.insertBefore(node, anchor);
    }

    node.classList.add('is-filtering');
    wire(node);
    sync(node);
  }

  function wire(node) {
    var track = node.querySelector('[data-fen-gift-track]');
    var prev = node.querySelector('[data-fen-gift-prev]');
    var next = node.querySelector('[data-fen-gift-next]');
    var textEl = node.querySelector('#fenGiftText');
    var saved = node.querySelector('[data-fen-gift-saved]');

    function step() {
      var card = track.querySelector('[data-fen-gift-card]:not(.is-hidden)');
      return card ? card.offsetWidth + 10 : 150;
    }

    function updateArrows() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    if (prev) prev.addEventListener('click', function () { track.scrollLeft -= step(); setTimeout(updateArrows, 350); });
    if (next) next.addEventListener('click', function () { track.scrollLeft += step(); setTimeout(updateArrows, 350); });
    track.addEventListener('scroll', updateArrows);
    updateArrows();

    node.querySelectorAll('[data-fen-gift-card]').forEach(function (card) {
      card.querySelector('[data-fen-gift-add]').addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var item = activeItem();
        if (!item) return;
        var variant = Number(card.dataset.variant);
        card.classList.add('is-busy');

        var line = boxLineFor(variant, item.handle);
        if (line) {
          changeLine(line.key, 0).then(function () { refresh(); });
        } else {
          var props = { _fen_voor: item.handle };
          props[FEN_T.forLabel] = item.title;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: props }] })
          })
            .then(function () { refresh(); })
            .catch(function () { card.classList.remove('is-busy'); });
        }
      });
    });

    if (textEl) {
      textEl.addEventListener('input', function () {
        if (saved) saved.classList.remove('show');
        clearTimeout(msgTimer);
        msgTimer = setTimeout(function () {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { 'Cadeaubericht': textEl.value } })
          }).then(function () {
            if (saved) {
              saved.classList.add('show');
              setTimeout(function () { saved.classList.remove('show'); }, 2000);
            }
          }).catch(function () {});
        }, 800);
      });
    }
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).catch(function () {});
  }

  function boxVariants() {
    var ids = {};
    TPL.content.querySelectorAll('[data-fen-gift-card]').forEach(function (c) { ids[Number(c.dataset.variant)] = true; });
    return ids;
  }

  // The cart line of box <variant> that belongs to product <handle>
  function boxLineFor(variant, handle) {
    if (!state.cart) return null;
    var found = null;
    state.cart.items.forEach(function (it) {
      if (it.variant_id === variant && it.properties && it.properties._fen_voor === handle) found = it;
    });
    return found;
  }

  function hasBox(handle) {
    if (!state.cart) return false;
    var ids = boxVariants();
    return state.cart.items.some(function (it) {
      return ids[it.variant_id] && it.properties && it.properties._fen_voor === handle;
    });
  }

  function activeItem() {
    for (var i = 0; i < state.items.length; i++) {
      if (state.items[i].handle === state.active) return state.items[i];
    }
    return state.items[0] || null;
  }

  // Cart data has no tags, so look each product up once per visit
  var tagCache = {};

  function tagsFor(handle) {
    if (tagCache[handle]) return Promise.resolve(tagCache[handle]);
    try { sessionStorage.removeItem('fenTags:' + handle); } catch (e) {}

    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : { tags: [] }; })
      .then(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
        tagCache[handle] = tags;
        return tags;
      })
      .catch(function () { return []; });
  }

  function fitsItem(card, item) {
    var wants = (card.dataset.match || '').split(',').filter(Boolean);
    return wants.some(function (t) { return t === 'alles' || item.tags[t]; });
  }

  // "Lattafa Atheeri — Eau de Parfum 100 ml" -> "Lattafa Atheeri"
  function shortName(title) {
    return String(title || '').split(/\s[—–-]\s/)[0];
  }

  function analyse(node, cart) {
    var ids = boxVariants();

    // Every product in the cart once (newest first), without the boxes
    var items = [];
    cart.items.forEach(function (it) {
      if (ids[it.variant_id]) return;
      if (items.some(function (x) { return x.handle === it.handle; })) return;
      items.push({ handle: it.handle, title: it.product_title, name: shortName(it.product_title) });
    });

    return Promise.all(items.map(function (it) { return tagsFor(it.handle); })).then(function (lists) {
      items.forEach(function (it, i) {
        it.tags = {};
        lists[i].forEach(function (t) { it.tags[t] = true; });
      });

      var cards = [].slice.call(node.querySelectorAll('[data-fen-gift-card]'));
      // Only products that have at least one box
      state.items = items.filter(function (it) {
        return cards.some(function (c) { return fitsItem(c, it); });
      });

      // A box whose product has left the cart goes too
      var handles = {};
      items.forEach(function (it) { handles[it.handle] = true; });
      var orphans = cart.items.filter(function (it) {
        return ids[it.variant_id] && it.properties && it.properties._fen_voor &&
          !handles[it.properties._fen_voor] && !removing[it.key];
      });
      if (orphans.length) {
        orphans.forEach(function (it) { removing[it.key] = true; });
        orphans.reduce(function (p, it) {
          return p.then(function () { return changeLine(it.key, 0); });
        }, Promise.resolve()).then(function () { refresh(); });
      }

      render(node);
    });
  }

  function render(node) {
    var items = state.items;
    var cards = [].slice.call(node.querySelectorAll('[data-fen-gift-card]'));
    var picker = node.querySelector('[data-fen-gift-picker]');
    var chips = node.querySelector('[data-fen-gift-chips]');
    var forLine = node.querySelector('[data-fen-gift-for]');

    if (!items.length) {
      node.classList.add('is-empty');
      node.classList.remove('is-filtering');
      return;
    }
    node.classList.remove('is-empty');

    // Keep the chosen product; otherwise the first one without a box yet
    if (!items.some(function (it) { return it.handle === state.active; })) {
      var open = items.filter(function (it) { return !hasBox(it.handle); });
      state.active = (open[0] || items[0]).handle;
    }
    var active = activeItem();

    // Product buttons (only with 2+ products that take a box)
    picker.hidden = items.length < 2;
    forLine.textContent = items.length < 2 ? FEN_T.fits + ' ' + active.name : '';
    chips.innerHTML = '';
    if (items.length > 1) {
      items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fen-gift__chip';
        b.setAttribute('aria-pressed', it.handle === active.handle ? 'true' : 'false');
        b.title = it.title;
        if (hasBox(it.handle)) {
          b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5 12 10 17 19 8"/></svg>';
        }
        var s = document.createElement('span');
        s.textContent = it.name;
        b.appendChild(s);
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          state.active = it.handle;
          render(node);
          var track = node.querySelector('[data-fen-gift-track]');
          track.scrollLeft = 0;
          track.dispatchEvent(new Event('scroll'));
        });
        chips.appendChild(b);
      });
    }

    // Boxes for the chosen product; the one already picked first
    cards.forEach(function (card) {
      var variant = Number(card.dataset.variant);
      var fits = fitsItem(card, active);
      var added = !!boxLineFor(variant, active.handle);
      card.classList.toggle('is-hidden', !fits);
      card.classList.toggle('is-added', added);
      card.classList.remove('is-busy');
      card.style.order = added ? -1 : 0;
      card.querySelector('.fen-gift__add-label').textContent = added ? FEN_T.added : FEN_T.add;
    });

    var ids = boxVariants();
    var anyAdded = state.cart.items.some(function (it) { return ids[it.variant_id]; });
    var msg = node.querySelector('[data-fen-gift-message]');
    if (msg) msg.classList.toggle('show', anyAdded);

    node.classList.remove('is-filtering');
    var track = node.querySelector('[data-fen-gift-track]');
    if (track) track.dispatchEvent(new Event('scroll'));
  }

  function sync(node) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        state.cart = cart;
        var textEl = node.querySelector('#fenGiftText');
        if (textEl && cart.attributes && cart.attributes['Cadeaubericht'] && !textEl.value) {
          textEl.value = cart.attributes['Cadeaubericht'];
        }
        return analyse(node, cart);
      })
      .catch(function () {
        node.querySelectorAll('[data-fen-gift-card]').forEach(function (c) { c.classList.remove('is-busy'); });
        node.classList.remove('is-filtering');
      });
  }

  // Re-check whenever the cart changes, however it changes
  var resyncTimer = null;
  function resyncSoon() {
    clearTimeout(resyncTimer);
    resyncTimer = setTimeout(function () {
      var live = document.getElementById('fenGiftBlock');
      if (live) sync(live);
    }, 500);
  }

  if (!window.__fenGiftFetchHooked) {
    window.__fenGiftFetchHooked = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(resyncSoon, resyncSoon);
      }
      return p;
    };
    document.addEventListener('cart:update', resyncSoon);
  }

  // Tell Horizon the cart changed (redraws the cart and the cart icon count);
  // fall back to a reload if it ignores us
  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'fenando-gift', data: { itemCount: cart.item_count, source: 'fenando-gift' } }
        }));
      })
      .catch(function () {});

    setTimeout(function () {
      var live = document.getElementById('fenGiftBlock');
      if (live) sync(live);
    }, 400);

    setTimeout(function () {
      var live = document.getElementById('fenGiftBlock');
      if (live && live.querySelector('.is-busy')) {
        sessionStorage.setItem('fenReopenCart', '1');
        window.location.reload();
      }
    }, 1600);
  }

  FEN.onDom(inject);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }

  if (sessionStorage.getItem('fenReopenCart') === '1') {
    sessionStorage.removeItem('fenReopenCart');
    setTimeout(function () {
      var opener = document.querySelector('[aria-controls*="cart"], [href$="/cart"], .header__cart, [class*="cart-icon"]');
      if (opener) opener.click();
    }, 600);
  }
})();
} catch (e) { if (window.console) console.error('Fenando: Gift boxes in the cart', e); }

/* ==================== Product cards in Sara chat ==================== */
try {
(function () {
  var cache = {};
  var ROOT = FEN.root;
  var DEC = FEN.t.dec;

  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + '/products/' + handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('not found');
        return r.json();
      })
      .then(function (p) {
        cache[handle] = p;
        return p;
      });
  }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', DEC);
  }

  function buildCard(p, handle) {
    var a = document.createElement('a');
    a.className = 'fen-chat-card';
    a.href = ROOT + '/products/' + handle;

    var img = p.featured_image || (p.images && p.images[0]) || '';
    var onSale = p.compare_at_price && p.compare_at_price > p.price;

    a.innerHTML =
      (img
        ? '<img class="fen-chat-card__img" src="' + img + '" alt="" width="52" height="52" loading="lazy">'
        : '<div class="fen-chat-card__img"></div>') +
      '<div class="fen-chat-card__body">' +
        '<p class="fen-chat-card__title">' + String(p.title).replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</p>' +
        '<span class="fen-chat-card__price">' +
          (onSale
            ? '<span class="fen-chat-card__was">' + money(p.compare_at_price) + '</span>' +
              '<span class="fen-chat-card__sale">' + money(p.price) + '</span>'
            : money(p.price)) +
        '</span>' +
      '</div>' +
      '<svg class="fen-chat-card__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';

    return a;
  }

  function enhance(msg) {
    if (msg.dataset.fenCards === '1') return;
    msg.dataset.fenCards = '1';

    var links = msg.querySelectorAll('a[href*="/products/"]');
    if (!links.length) return;

    var handles = [];
    links.forEach(function (link) {
      var m = link.getAttribute('href').match(/\/products\/([a-z0-9\-_%]+)/i);
      if (m && handles.indexOf(m[1]) === -1) handles.push(m[1]);
    });
    if (!handles.length) return;

    var holder = document.createElement('div');
    holder.className = 'fen-chat-cards';
    msg.appendChild(holder);

    handles.slice(0, 3).forEach(function (handle) {
      getProduct(handle)
        .then(function (p) {
          holder.appendChild(buildCard(p, handle));
          var box = document.getElementById('fenChatMessages');
          if (box) box.scrollTop = box.scrollHeight;
        })
        .catch(function () { /* product gone — leave the text link */ });
    });
  }

  function scan() {
    document.querySelectorAll('.fen-chat-message.assistant').forEach(enhance);
  }

  var box = document.getElementById('fenChatMessages');
  if (box) {
    new MutationObserver(function () { scan(); }).observe(box, { childList: true, subtree: true });
    scan();
  } else {
    // Chat not in the DOM yet — watch for it
    FEN.onDom(function () {
      if (document.getElementById('fenChatMessages')) scan();
    });
  }
})();
} catch (e) { if (window.console) console.error('Fenando: Product cards in Sara chat', e); }

/* ==================== AI image note ==================== */
try {
(function () {
  var TPL = document.getElementById('fenAiNoteTemplate');
  if (!TPL) return;

  function make(variant) {
    var node = TPL.content.firstElementChild.cloneNode(true);
    node.classList.add('fen-ai-note--' + variant);
    node.setAttribute('data-fen-ai-note', variant);
    return node;
  }

  function placeProduct() {
    if (document.querySelector('[data-fen-ai-note="product"]')) return;

    // Only the big gallery on the product page, never a product card
    // (search results and recommendations also contain slideshows)
    var gallery = document.querySelector('.product-information__media slideshow-component');
    if (!gallery || !gallery.parentElement) return;

    var host = gallery.parentElement;
    host.appendChild(make('product'));
  }

  function placeFooter() {
    if (document.querySelector('[data-fen-ai-note="footer"]')) return;

    var anchor =
      document.querySelector('.fen-footer__bottom') ||
      document.querySelector('.fen-footer__main');
    if (!anchor || !anchor.parentNode) return;

    anchor.parentNode.insertBefore(make('footer'), anchor);
  }

  function run() {
    placeFooter();
    if (IS_PRODUCT) placeProduct();
  }

  var IS_PRODUCT = FEN.pageType === 'product';

  FEN.onDom(run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 500);
})();
} catch (e) { if (window.console) console.error('Fenando: AI image note', e); }

/* ==================== Phone layout ==================== */
try {
(function () {
  var phone = window.matchMedia('(max-width: 749px)');
  var T = { account: FEN.t.account, more: FEN.t.more, less: FEN.t.less, filter: FEN.t.filter, sort: FEN.t.sort };
  var ACCOUNT_URL = FEN.accountUrl;

  // ☰ menu: account link at the bottom (the header icon is hidden on phones)
  function account() {
    var nav = document.querySelector('.menu-drawer__navigation');
    if (!nav || nav.querySelector('.fen-m-account')) return;
    var a = document.createElement('a');
    a.className = 'fen-m-account';
    a.href = ACCOUNT_URL;
    a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg><span></span>';
    a.querySelector('span').textContent = T.account;
    nav.appendChild(a);
  }

  // Engraving story: "Lees meer"
  function craft() {
    var p = document.querySelector('.fen-craft__p');
    if (!p || p.nextElementSibling && p.nextElementSibling.classList.contains('fen-m-more')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fen-m-more';
    b.textContent = T.more;
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = p.classList.toggle('is-open');
      b.textContent = open ? T.less : T.more;
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    p.parentNode.insertBefore(b, p.nextSibling);
    // Desktop shows the whole text; the button is only for phones
    function sync() { b.hidden = !phone.matches || p.scrollHeight <= p.clientHeight + 2 && !p.classList.contains('is-open'); }
    sync();
    phone.addEventListener('change', sync);
  }

  // Footer: each link group folds open on phones
  function footer() {
    document.querySelectorAll('.fen-footer__main-inner > div').forEach(function (col, i) {
      var title = col.querySelector('.fen-footer__col-title');
      var list = col.querySelector('.fen-footer__links');
      if (!title || !list || title.querySelector('.fen-m-fold')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fen-m-fold';
      b.textContent = title.textContent.trim();
      list.id = list.id || 'fenFootLinks' + i;
      b.setAttribute('aria-controls', list.id);
      title.textContent = '';
      title.appendChild(b);
      function set(open) {
        col.classList.toggle('fen-m-folded', !open);
        // Only a real toggle on phones; on larger screens the links always show
        if (phone.matches) b.setAttribute('aria-expanded', open ? 'true' : 'false');
        else b.removeAttribute('aria-expanded');
      }
      set(false);
      phone.addEventListener('change', function () { set(!col.classList.contains('fen-m-folded')); });
      b.addEventListener('click', function () { if (phone.matches) set(col.classList.contains('fen-m-folded')); });
    });
  }

  // Collection: Filter | Sorteer bar that stays at the top
  function collectionBar() {
    var layout = document.querySelector('.fen-col__layout');
    if (!layout || typeof window.fenOpenFilter !== 'function' || document.querySelector('.fen-m-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'fen-m-bar';
    bar.innerHTML =
      '<button type="button" data-fen-m="filter"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><line x1="4" y1="7" x2="20" y2="7"/><line x1="7" y1="12" x2="17" y2="12"/><line x1="10" y1="17" x2="14" y2="17"/></svg><span></span><span class="fen-m-bar__count"></span></button>' +
      '<button type="button" data-fen-m="sort"><span></span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg></button>';
    bar.querySelector('[data-fen-m="filter"] span').textContent = T.filter;
    bar.querySelector('[data-fen-m="sort"] span').textContent = T.sort;
    bar.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        window.fenOpenFilter();
        // Sort: open the sort group and bring it into view
        if (b.getAttribute('data-fen-m') === 'sort') {
          var opt = document.querySelector('#fenFilterPanel .fen-filter-sort-option');
          var sec = opt && opt.closest('.fen-filter-section');
          if (sec) sec.scrollIntoView({ block: 'start' });
        }
      });
    });
    layout.parentNode.insertBefore(bar, layout);
    syncCount();
  }

  function syncCount() {
    var src = document.getElementById('fenFilterCount');
    var dst = document.querySelector('.fen-m-bar__count');
    if (!dst) return;
    var n = src && src.classList.contains('visible') ? src.textContent.trim() : '';
    if (dst.textContent !== n) dst.textContent = n;
  }

  // Product photo: "1 / 8" counter on the photo
  function counter() {
    var ss = document.querySelector('.product-information__media slideshow-component');
    if (!ss) return;
    var dots = ss.querySelectorAll('.slideshow-controls__dots button');
    if (!dots.length) dots = ss.querySelectorAll('.slideshow-controls__dots li');
    if (dots.length < 2) return;
    var c = ss.querySelector('.fen-m-counter');
    if (!c) {
      c = document.createElement('span');
      c.className = 'fen-m-counter';
      c.setAttribute('aria-hidden', 'true');
      ss.appendChild(c);
    }
    var cur = 1;
    dots.forEach(function (d, i) {
      if (d.getAttribute('aria-selected') === 'true' || d.getAttribute('aria-current') === 'true' ||
          d.classList.contains('is-active') || d.classList.contains('active')) cur = i + 1;
    });
    var txt = cur + ' / ' + dots.length;
    if (c.textContent !== txt) c.textContent = txt;

    var row = ss.querySelector('.fen-m-dots');
    if (!row || row.children.length !== dots.length) {
      if (row) row.remove();
      row = document.createElement('span');
      row.className = 'fen-m-dots';
      row.setAttribute('aria-hidden', 'true');
      for (var k = 0; k < dots.length; k++) row.appendChild(document.createElement('span'));
      ss.appendChild(row);
    }
    for (var j = 0; j < row.children.length; j++) {
      var on = j === cur - 1;
      if (row.children[j].classList.contains('is-on') !== on) row.children[j].classList.toggle('is-on', on);
    }
  }

  function run() {
    account();
    craft();
    footer();
    collectionBar();
    syncCount();
    counter();
  }

  // Page changes through the shared watcher; slide changes (attributes) here
  FEN.onDom(run);
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['aria-selected', 'aria-current', 'class'] });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
} catch (e) { if (window.console) console.error('Fenando: Phone layout', e); }

/* ==================== Product cards: hover photo only where hovering exists ==================== */
try {
(function () {
  // Phones and tablets never show the second (hover) photo, so it is not downloaded there
  if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
  function strip() {
    document.querySelectorAll('img.fen-pcard__img--alt').forEach(function (img) { img.remove(); });
  }
  strip();
  FEN.onDom(strip);
})();
} catch (e) { if (window.console) console.error('Fenando: Product cards: hover photo only where hovering exists', e); }
